export default "__VITE_ASSET__CUmeoQb4__"